import { render, staticRenderFns } from "./SvgIconMenu.vue?vue&type=template&id=3b414293&"
var script = {}
import style0 from "./SvgIconMenu.vue?vue&type=style&index=0&id=3b414293&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports